import {
  DivList,
  HeaderContainer,
  HeaderText,
  OptionText,
} from '../OnBoardingModal.styles';
import { IHeading, IHeadingChildren } from '../helpers/HeadingsCalc';

interface HeaderListProps {
  page: IHeading;
  onPageChange: (child: IHeadingChildren) => void;
  activePageId: string;
}
export function HeaderList({
  onPageChange,
  page,
  activePageId,
}: HeaderListProps) {
  const children = Array.from(page.children.values());

  return (
    <HeaderContainer isSelected={page.children.has(activePageId)}>
      <HeaderText
        onClick={() => {
          const firstChild = children.at(0);
          if (firstChild) onPageChange(firstChild);
        }}
      >
        {page.name}
      </HeaderText>
      <DivList>
        {children.map(child => {
          return (
            <OptionText
              key={child.id}
              isSelected={activePageId === child.id}
              onClick={() => {
                onPageChange(child);
              }}
            >
              {child.name}
            </OptionText>
          );
        })}
      </DivList>
    </HeaderContainer>
  );
}
